import React from 'react';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

const DeathCertificateContent = ({ taxpayer, transactionInfo }) => {
  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  return (
    <>
      <div className="card-section-content container-fluid citizen-tabs">
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(
                          transactionInfo,
                          'included.taxPayer.attributes.photo'
                        ) !== '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(
                              transactionInfo,
                              'included.taxPayer.attributes.photo'
                            )}
                          />
                        ) : (
                          getInitials(
                            `${_.get(taxpayer, 'first_name')} ${_.get(
                              taxpayer,
                              'middle_name'
                            )} ${_.get(taxpayer, 'last_name')}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'first_name') || '-'} ${
                          _.get(taxpayer, 'middle_name') || ''
                        } ${_.get(taxpayer, 'last_name') || ''} ${
                          _.get(taxpayer, 'extension_name') || ''
                        } `}
                      </h1>
                    </div>
                    <div className="d-flex ml-auto">&nbsp;</div>
                  </div>
                  <TransactionInformation
                    module="death"
                    transactionInfo={transactionInfo}
                    taxpayer={taxpayer}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-1 pb-1 px-3">
            <div className="col-12">
              <table className="transaction-table table table-borderless table-sm table-striped table-hover">
                <tbody>
                  <tr>
                    <td className="text-dark" width="300">
                      No. of Copies
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'number_of_copies') || '--')}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      What to Print
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'what_to_print') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-success" colSpan={3}>
                      <b>OWNER&apos;s PERSONAL INFORMATION</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'first_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'middle_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'last_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Extension Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'extension_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Sex
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{(_.get(taxpayer, 'gender') || '--').toUpperCase()}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Date of Death
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {moment(_.get(taxpayer, 'death_date')).format(
                          'MM/DD/YYYY'
                        ) || '--'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-success" colSpan={3}>
                      <b>REQUESTOR&apos;s INFORMATION</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'requestors_first_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'requestors_middle_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'requestors_last_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Extension Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'requestors_extension_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Mailing Address
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{_.get(taxpayer, 'mailing_address') || '--'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Zip Code
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'mailing_zip_code') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Telephone No.
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'telephone_number') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Mobile Number.
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'mobile_number') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Requester&apos;s Tax Identification Number (TIN)
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'tin_number') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

DeathCertificateContent.defaultProps = {
  taxpayer: {},
  transactionInfo: {},
};

DeathCertificateContent.propTypes = {
  taxpayer: PropTypes.instanceOf(Object),
  transactionInfo: PropTypes.instanceOf(Object),
};

export default DeathCertificateContent;
